var map = {
	"./arc.svg": 88669,
	"./assaultDirection.svg": 3907,
	"./attackArrow.svg": 25022,
	"./circle.svg": 77183,
	"./closedCurve.svg": 27584,
	"./curve.svg": 86800,
	"./doubleArrow.svg": 34295,
	"./ellipse.svg": 88255,
	"./fineArrow.svg": 21830,
	"./freeHandPolygon.svg": 41608,
	"./freeHandPolyline.svg": 33806,
	"./gatheringPlace.svg": 62279,
	"./lune.svg": 55893,
	"./point.svg": 46199,
	"./polygon.svg": 3551,
	"./polyline.svg": 42483,
	"./rectangle.svg": 39038,
	"./sector.svg": 18113,
	"./squadCombat.svg": 12603,
	"./straightArrow.svg": 38928,
	"./tailedAttackArrow.svg": 83653,
	"./tailedSquadCombat.svg": 16568
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46669;